import React, { useState, useEffect, useMemo } from 'react';

import _ from 'lodash';
import useLegoData from "../data-caches/useLegoData";
import useModelsData from '../data-caches/useModelsData';
import { GEN_COLORS, RESTYLE_COLORS, TRIM_FIELD_COLORS_MAPPING, modelTypeColor } from './TrimColors';



function TrimSpec({ spec, value, children = null, hideBaseGen = false, fullInfo = false, className = "", showSpec = false, style = {},  ...otherProps }) {
  const specs = useLegoData('trimSpecs', {});
  const data = useModelsData();

  const getColor = ([field, val]) => {
    // Prefer the color for the modelId's actual wildcard type (family/submodel/model), so a modelId
    // that is really a family or submodel is badged accordingly rather than always as a plain model.
    return modelTypeColor(data.modelTypeOf(val)) || TRIM_FIELD_COLORS_MAPPING[field] || 'dark';
  }

  const [fieldCategory] = spec.split('_');
  let color = TRIM_FIELD_COLORS_MAPPING[spec] || TRIM_FIELD_COLORS_MAPPING[fieldCategory] || (specs[spec] ? 'info' : 'danger');

  let not = null;
  let label = (value || '').toString();
  if (label.slice(0, 1) === '!') {
    not = <span className={'small badge badge-warning'}>NOT</span>;
    label = label.slice(1);
  }

  if(spec === '_inherit' && value === 'no') {
    label="Inherit-NO"
  }

  if (spec === 'genId') {
    let [, baseGen, todo, at, genN, genVariation, restyleN] = (label || '').toString().match(/^(@.+)((@G)(\d+)([A-F])?(?:\.(\d+))?)/) || [];
    if (genN) {
      color = GEN_COLORS[genN] || 'info';

      if (restyleN) {
        style.borderBottom = `1px solid`;
        style.borderRight = `5px solid`;
        className += ` border-${RESTYLE_COLORS[restyleN] || 'info'}`;
      }

      if (hideBaseGen) {
        baseGen = '';
      }
      let genText = `${baseGen}@G${genN}${genVariation ? `${genVariation}` : ''}${restyleN ? `.${restyleN}` : ''}`;

      const genInfo = data.getBaseGenDef(label);

      
      if (genInfo) {
        let {name, codenames, fromYear, toYear, remappedToGenId} = genInfo;

        // A remapped generation is an alias/redirect onto another gen — show it muted + struck through,
        // with a `⤳ target` indicator, so it's visually distinct from a live generation.
        let remappedIndicator = null;
        if (remappedToGenId) {
          color = 'secondary';
          remappedIndicator = (
            <span className='monospace font-weight-normal text-white' title={`Remapped to ${remappedToGenId}`}>
              {' '}⤳ {fullInfo ? remappedToGenId : remappedToGenId.replace(/^@.*@G/, 'G')}
            </span>
          );
        }

        if(name || codenames?.length || remappedToGenId || (fullInfo && (fromYear || toYear))) {
          label = <>
            <span className={remappedIndicator ? 'text-strike translucent' : ''}>{genText}</span> <em className={'font-weight-normal'}>{name}</em>
            {codenames?.length ? <span className='monospace'> {codenames?.join(', ')}</span> : null}
            {fullInfo && (fromYear || toYear) ? <span className='badge badge-light text-secondary ml-1'>{fromYear}-{toYear}</span> : null}
            {remappedIndicator}
          </>;
        } else {
          label = genText;
        }
      } else {
        label = genText;
      }
    }
    
    showSpec = false;
  } else if (spec === 'modelId') {
    color = getColor([spec, label]);
  }

  return <span className={`badge badge-${color} inline-block align-middle ${className}`} title={`${spec}=${value}`} style={style} {...otherProps}>
    <div className={not ? 'text-warning' : ''}>{not} {children || label}</div>
    {showSpec ? <div className={'zoom-75 translucent'}>{spec}</div> : null}
  </span>
};

// export default React.memo(TrimSpec);
export default TrimSpec;

// let res = <span className={'badge badge-success'}>COPY</span>
// export default ({spec, value}) => res;
